import { render, staticRenderFns } from "./FranchiseeBalance.vue?vue&type=template&id=245589e2&"
import script from "./FranchiseeBalance.vue?vue&type=script&lang=js&"
export * from "./FranchiseeBalance.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseeBalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports